import RouteManager from "./RouteManager"

export { RouteApp } from "./RouteApp"

export default RouteManager
